/**
 * VAL-WELCOME-1 — what a client sees when an engagement is missing (404) or
 * belongs to another firm (403). House text only; no status line, no code.
 */
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function _ValuationNotFound() {
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center gap-4 py-16 text-center">
      <p className="text-sm text-gray-900">
        We couldn't find that valuation. It may belong to another firm, or it may have been removed.
      </p>
      <Link to="/valuation" className="inline-block">
        <Button type="button">Back to your valuations</Button>
      </Link>
    </div>
  )
}
